import Select from "react-select";
import CustomLabel from "../../common/CustomLabel";
import { filterOptions } from "../../SubmitTip/resources";

const FilterCriteriaSelect = ({
  handleFilterChange,
}: {
  handleFilterChange: (selectedOptions: any) => void;
}) => (
  <CustomLabel
    labelText="Filter Options"
    labelTextClass="!text-center !w-full"
    isRequired
  >
    <Select
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={{
        control: (provided) => ({
          ...provided,
          borderRadius: "24px",
          padding: "4px 8px",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#ddd" : "transparent",
        }),
      }}
      isMulti
      className="font-medium text-[14px] leading-4 cursor-pointer"
      placeholder="Select filter options"
      onChange={handleFilterChange}
      options={filterOptions}
    />
  </CustomLabel>
);

export default FilterCriteriaSelect;
